import { motion } from 'framer-motion';
import styled from 'styled-components';
import { AnimationProps } from './types';

export const Animation = styled(motion.div)<AnimationProps>`
    display: ${({ flex }) => (flex ? 'flex' : 'block')};
`;
